export default {"src":"/_next/static/media/menu-arrow-left.75d8713e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};